<template>
    <project-step-container
            prev-to="go_broad_to_go_narrow_9"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-3">
            <b-col cols="12">
                <img width="100%" src="../Images/image-techniques.svg" tabindex="0"
                     alt="Two people organizing a lot of ideas on a white board">
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
                {{getMessage(10 , 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide100Narrowing" icon-name="icon-guide" :text=" getMessage(10 , 'gobroadtogonarrow-guide')"></LinkStyleGuide>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide2By2Narrowing" icon-name="icon-guide" :text=" getMessage(10 , 'gobroadtogonarrow-guide-2')"></LinkStyleGuide>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import {Steps} from "@/modules/D4D/Utils";

    export default {
        name: "GoBroadToGoNarrow10",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_GO_NARROW_TECHNIQUES,
                styleGuide: {}
            }
        },
        methods: {
            openGuide100Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.POINTS_NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            openGuide2By2Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'go_broad_to_go_narrow_11', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
